import React, { Component } from "react";
import Api from "../../Api";
import PhoneInput from "react-phone-number-input";

class Opzeggingen extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showModal: false,
      loading: false,
    };

    this.TextField = this.TextField.bind(this);
    this.EmailField = this.EmailField.bind(this);
    this.PhoneField = this.PhoneField.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
  }

  async onSubmit(data) {
    const today = new Date();
    this.setState({ loading: true });

    const opzeggen = {
      91369: data.voornaam,
      91370: data.achternaam,
      91372: data.tussenvoegsels,
      91373: data.email,
      91374: data.phone,
      91375: data.lidmaatschap,
      91376: `<p>${data.opzegging}</p>`,
      91377: [],
      91378: today.toISOString(),
      defDossier: "4497",
    };

    const resultOpzeggen = await Api.dossiers.Create(opzeggen);
 
    this.setState({ loading: false });
    this.setState({ showModal: true });
  }

  TextField(label, name, rules) {
    const {
      register,
      formState: { errors },
    } = this.props;

    return (
      <>
        <div className="flex flex-col items-start">
          <label
            htmlFor="tussenvoegsels"
            className="form-label fw-bold float-start"
          >
            {rules.required && <span className="text-red-500">*</span>} {label}
          </label>
          <input
            {...register(name, rules)}
            type="text"
            className="h-8 border rounded px-2 w-full bg-gray-50"
            onChange={(e) => {
              this.setState({ [name]: e.target.value });
            }}
          />
          {errors[name] && (
            <span className="text-red-500 text-sm">This field is required</span>
          )}
        </div>
      </>
    );
  }

  EmailField(label, name, rules) {
    const {
      register,
      formState: { errors },
    } = this.props;

    return (
      <>
        <div className="flex flex-col items-start">
          <label
            htmlFor="tussenvoegsels"
            className="form-label fw-bold float-start"
          >
            {rules.required.value && <span className="text-red-500">*</span>}{" "}
            {label}
          </label>
          <input
            {...register(name, rules)}
            type="email"
            className="h-8 border rounded px-2 w-full bg-gray-50"
            onChange={(e) => {
              this.setState({ [name]: e.target.value });
            }}
          />
          {errors[name]?.type === "required" && (
            <span className="text-red-500 text-sm">{errors[name].message}</span>
          )}
        </div>
      </>
    );
  }

  PhoneField(label, name, rules) {
    const {
      register,
      formState: { errors },
    } = this.props;

    return (
      <>
        <div className="flex flex-col items-start">
          <label
            htmlFor="tussenvoegsels"
            className="form-label fw-bold float-start"
          >
            {rules.required && <span className="text-red-500">*</span>} {label}
          </label>
          <PhoneInput
            placeholder="Enter phone number"
            {...register(name, rules)}
            value={this.state[name]}
            onChange={(value) => this.setState({ [name]: value })}
            className="h-8 border rounded px-2 w-full bg-gray-50"
          />

          {errors[name]?.type === "required" && (
            <span className="text-red-500 text-sm">{errors[name].message}</span>
          )}
        </div>
      </>
    );
  }

  TextAreaField(label, name, rules) {
    const {
      register,
      formState: { errors },
    } = this.props;

    return (
      <>
        <div className="flex flex-col items-start w-full">
          <label
            for="tussenvoegsels"
            className="form-label fw-bold float-start"
          >
            {rules.required && <span className="text-red-500">*</span>} {label}
          </label>
          <textarea
            rows={7}
            {...register(name, rules)}
            onChange={(e) => {
              this.setState({ [name]: e.target.value });
            }}
            className="block p-2 w-full text-sm text-gray-900  rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 "
          ></textarea>

          {errors[name] && (
            <span className="text-red-500 text-sm">This field is required</span>
          )}
        </div>
      </>
    );
  }

  render() {
    const { handleSubmit } = this.props;
    return (
      <>
        {this.state.loading && (
          <div className="flex items-center justify-center h-screen fixed w-full z-50">
            <div className="bg-slate-500 absolute w-full h-full  opacity-50"></div>
            <div class="relative">
              <div className="h-24 w-24 rounded-full border-t-8 border-b-8 border-slate-200"></div>
              <div className="absolute top-0 left-0 h-24 w-24 rounded-full border-t-8 border-b-8 border-slate-300 animate-spin"></div>
            </div>
          </div>
        )}
        {this.state.showModal && (
          <div
            id="successModal"
            tabindex="-1"
            aria-hidden="true"
            class="flex  overflow-y-auto overflow-x-hidden fixed top-0 right-0 left-0 z-50 justify-center items-center w-full md:inset-0 h-modal md:h-full"
          >
            <div className="bg-slate-500 absolute w-full h-full opacity-50"></div>
            <div class="relative p-4 w-full max-w-md h-full md:h-auto">
              <div class="relative p-4 text-center bg-white rounded-lg shadow dark:bg-gray-800 sm:p-5">
                <button
                  onClick={() => {
                    this.setState({ showModal: false });
                  }}
                  type="button"
                  class="text-gray-400 absolute top-2.5 right-2.5 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center dark:hover:bg-gray-600 dark:hover:text-white"
                  data-modal-toggle="successModal"
                >
                  <svg
                    aria-hidden="true"
                    class="w-5 h-5"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                      clip-rule="evenodd"
                    ></path>
                  </svg>
                  <span class="sr-only">Close modal</span>
                </button>
                <div class="w-12 h-12 rounded-full bg-green-100 dark:bg-green-900 p-2 flex items-center justify-center mx-auto mb-3.5">
                  <svg
                    aria-hidden="true"
                    class="w-8 h-8 text-green-500 dark:text-green-400"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                      clip-rule="evenodd"
                    ></path>
                  </svg>
                  <span class="sr-only">Success</span>
                </div>
                <p class="mb-4 text-lg font-semibold text-gray-900 dark:text-white">
                  Successfully!
                </p>
                <button
                  onClick={() => {
                    this.setState({ showModal: false });
                  }}
                  type="button"
                  class="py-2 px-3 text-sm font-medium text-center text-white rounded-lg bg-blue-600 hover:bg-blue-700 focus:ring-4 focus:outline-none focus:ring-blue-300 "
                >
                  Continue
                </button>
              </div>
            </div>
          </div>
        )}
        <div className="py-5 px-36 d-flex flex-column gap-5">
          <div className=" bg-white rounded-lg shadow-md border border-gray-200 py-6 px-10">
            <p className="text-start text-xl spt-2 mt-2 font-bold">
              Lidmaatschap opzeggen
            </p>
            <div className="mt-6" onSubmit={this.submitForm}>
              <form className="grid grid-cols-3 gap-4 mt-3">
                {this.TextField("Voornaam", "voornaam", {
                  required: true,
                })}
                {this.TextField("Tussenvoegsels", "tussenvoegsels", {
                  required: false,
                })}
                {this.TextField("Achternaam", "achternaam", {
                  required: true,
                })}
                {this.TextField("Lidmaatschap nr.", "lidmaatschap", {
                  required: true,
                })}
                {this.EmailField("E-mailadres", "email", {
                  required: { value: true, message: "Email is required" },
                })}
                {this.PhoneField("Mobiel nr. (WhatsApp)", "phone", {
                  required: "This Field Is Required",
                })}
              </form>
            </div>

            <div onSubmit={this.submitForm}>
              <form className="grid grid-cols-1 gap-4 mt-3">
                {this.TextAreaField("Reden van opzegging", "opzegging", {
                  required: "This Field Is Reuired",
                })}
              </form>
            </div>

            <div className="mt-3" onSubmit={handleSubmit(this.onSubmit)}>
              <form>
                <button
                  type="submit"
                  className="bg-orange-500 text-white font-bold px-6 py-2 rounded-3xl flex justify-center items-center hover:border hover:border-orange-500 transition duration-300 ease-in-out"
                >
                  OPSLAAN
                </button>
              </form>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default Opzeggingen;
